import * as s from "../LyveStyled";
import TextArea from "components/atoms/input/TextArea";
import { ReactComponent as OnlineIcon } from "assets/icons/online.svg";
import { IoMdCopy } from "react-icons/io";
import BigButton from "components/atoms/buttons/BigButton";

type SuccessProps = {
  subscriptionKey: string;
  onCopy: () => void;
  onModal: () => void;
};

export default function SuccessModal({
  subscriptionKey,
  onCopy,
  onModal,
}: SuccessProps) {
  return (
    <s.StepContainer>
      <s.SuccessContainer>
        <p>
          <b>
            <OnlineIcon /> Success
          </b>
          A Subscription Key has been generated.
        </p>
        <s.SuccessKeyContainer>
          <TextArea value={subscriptionKey} style={{ height: 300 }} readOnly />
          <s.CopyButton
            onClick={onCopy}
            data-testid="subscription-lyve-add-copy-button-copy"
          >
            <IoMdCopy />
          </s.CopyButton>
        </s.SuccessKeyContainer>
      </s.SuccessContainer>
      <s.StepButtonContainer>
        <BigButton
          label="Close"
          buttonType="cancel"
          onClickBtn={onModal}
          data-testid="subscription-lyve-add-button-modal"
        />
      </s.StepButtonContainer>
    </s.StepContainer>
  );
}
